import React from 'react';

export default function TestiThumb({ t, size = 110, radius = 8 }) {
  let src = '', isVideo = false;
  if (t?.photos?.length > 0) src = t.photos[0];
  else if (t?.videos?.length > 0) { src = t.videos[0].replace(/\.(mp4|mov|avi|mkv|webm|m4v)(\?.*)?$/i, '.jpg'); isVideo = true; }
  else if (t?.videoUrl) {
    isVideo = true;
    const yt = t.videoUrl.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
    if (yt) src = 'https://img.youtube.com/vi/' + yt[1] + '/hqdefault.jpg';
  }
  if (!src && !isVideo) return null;
  return (
    <div style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
      {src
        ? <img src={src} alt="" style={{ width: size, height: size, objectFit: 'cover', borderRadius: radius }} />
        : <div style={{ width: size, height: size, borderRadius: radius, background: '#1a1010', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: Math.round(size/4) }}>{'\u25b6'}</div>}
      {isVideo && src && <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><div style={{ width: Math.round(size*0.29), height: Math.round(size*0.29), borderRadius: '50%', background: 'rgba(0,0,0,0.55)', color: '#fff', fontSize: Math.round(size*0.13), display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{'\u25b6'}</div></div>}
    </div>
  );
}
